/**
 * Onboarding Service
 * Handles API calls for onboarding completion
 * Task 009 - Onboarding Flow
 */

import apiClient from '../lib/apiClient';
import { OnboardingResponses } from '../contexts/OnboardingContext';

interface GenerateBudgetResponse {
  plan_id: string;
  plan_name: string;
  groups_created: number;
  categories_created: number;
  message: string;
}

/**
 * Generate budget structure based on onboarding responses
 * @param responses - Onboarding responses from the survey
 * @param language - Language preference for category names ('id' or 'en')
 */
export const generateBudget = async (responses: OnboardingResponses, language: string = 'id'): Promise<GenerateBudgetResponse> => {
  return apiClient.post('/auth/generate-budget', {
    responses: {
      life_companions: responses.lifeCompanions,
      housing_type: responses.housingType,
      has_kpr: responses.hasKPR,
      loans: responses.loans,
      transportation: responses.transportation,
      monthly_expenses: responses.monthlyExpenses,
      subscriptions: responses.subscriptions,
      infrequent_expenses: responses.infrequentExpenses,
      savings_priorities: responses.savingsPriorities,
      fun_expenses: responses.funExpenses,
      language: language,
    }
  });
};

/**
 * Complete onboarding by setting onboarding_done to true
 */
export const completeOnboarding = async (): Promise<{ message: string }> => {
  return apiClient.patch('/auth/complete-onboarding');
};
